enum Routes {
  Smt = 'introduction',
  Jobs = 'jobs',
  Works = 'works',
  Contact = 'contact',
}

export default Routes;